module.exports = __webpack_public_path__ + "static/media/brego35923.ffb42d6a.jpg";